import { Link } from "react-router-dom";

const Submit = ({ path = "", click = null, left = "", submit }) => {
	return (
		<div>
			{path && (
				<Link className="btn btn-default" to={path}>
					<i className="fa fa-angle-left" /> &nbsp;{left}
				</Link>
			)}
			{click && (
				<button type="button" className="btn btn-default" onClick={click}>
					<i className="fa fa-angle-left" /> &nbsp;{left}
				</button>
			)}
			{(path || click) && <span>|</span>}
			<button type="submit" className="btn btn-primary">
				{submit}&nbsp; <i className="fa fa-angle-right" />
			</button>
		</div>
	);
};

export default Submit;
